import React, { Component } from "react";
import styled from "styled-components";
import * as actions from "../../store/actions";
import Icon from "../UI/Icon/Icon";
import { connect } from "react-redux";

import VoiceContentSearchResult from "../Dashboard/Meetings/VoiceContentSearchResult/VoiceContentSearchResult";
import moment from "moment";

import { PurpleDottedSpinner } from "../UI/Spinners/DottedSpinner";
// import { Link } from "react-router-dom";

const CustomSpinner = styled(PurpleDottedSpinner)`
  /* padding: 72px auto; */
  /* left: calc(50% - 25px); */
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  margin-top: auto;
  position: absolute;
`;
const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const PlaceHolderHelp = styled.p`
  color: lightgrey;
  margin: 0;
`;
const TextResultContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const PanelContainer = styled.div`
  background-color: #fff;
  position: relative;
  padding: 20px;
  width: 100%;
  height: calc(60vh + 100px);
  border-radius: 3px;
  border: 1px solid rgba(23, 15, 48, 0.25);
  border-top: 0px;
  background: rgba(0, 0, 5, 0.3);
  background: white;

  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  overflow: scroll;
  // border-radius: 10px;
  // border: 1px solid rgba( 255, 255, 255, 0.18 );
`;
const BoundingBox = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 0, 0.5);
  left: ${(props) => props.x * props.scale * 0.67 + "px"};
  top: ${(props) => props.y * props.scale * 0.67 + "px"};
  width: ${(props) => props.width * props.scale * 0.67 + "px"};
  height: ${(props) => props.height * props.scale * 0.67 + "px"};
  border: 1px solid rgba(0, 0, 0, 0.2);
`;
const BoundingBoxes = styled.div`
  position: relative;
  z-index: 2;
`;
const MeetingResult = styled.p`
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
  color: blue;
`;

const InformationalTextForSearch = styled.div`
  margin: 20px;
  color: black;
`;
const Heading = styled.h2`
  color: black;
  font-size: 1rem;
  margin-bottom: 10px;
  text-transform: capitalize;
`;

const FilterButtonsContainer = styled.div`
  width: fit-content;
  margin: 20px;
  display: flex;
  gap: 0.5rem;
  z-index: 11;
`;
const FilterButton = styled.button`
  background-color: ${({ enabled }) => (enabled ? "#000" : "#c3c3c3")};
  color: ${({ enabled }) => (enabled ? "#fff" : "#000")};
  padding: 8px 16px;
  width: 100px;

  margin: 0 4px;
  border: none;
  border-radius: 18px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 35px;
`;

const CrossIcon = styled.span`
  font-size: 1.5em;
  margin-left: 8px;
  cursor: pointer;
`;
const SearchBarContainer = styled.div`
  width: 100%;
  margin-bottom: 6px;
  // border: 1px solid red;
`;
const SearchInputBar = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 100%;
`;
const SingleTextResult = styled.div`
  /* border: 2px solid yellow; */
`;
const ResultPlaceHolder = styled.p`
  color: black;
  font-size: 1rem;
  font-weight: 400;
`;
const InputVioletBorder = styled.input`
  &::placeholder {
    color: #170f30;
    opacity: 0.25;
    font-weight: 400;
  }

  &:focus {
    border: 1px solid #9471ff;
  }

  outline: none;
  color: #354052;
  font-weight: bold;
  font-size: 14px;
  height: 48px;
  line-height: 48px;
  border: 1px solid rgba(23, 15, 48, 0.25);
  border-radius: 3px;
  padding: 0 34px 0 18px;
  width: 100%;
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 14px;
  display: flex;
  align-items: center;
  gap: 20px;
  top: calc(50% - 7.5px);
  cursor: pointer;
`;

class SearchPanel extends Component {
  state = {
    filters: {
      voice: true,
      text: true,
    },
    selectedFilters: ["voice", "text"],
    showPanel: false,
    query: "",
    voiceMatchedResults: "",
    textMatchedResults: "",
    voiceResultLoading: false,
    textResultLoading: false,
  };
  toggleFilter = (filter) => {
    this.setState((prevState) => {
      const isSelected = prevState.selectedFilters.includes(filter);

      return {
        filters: {
          ...prevState.filters,
          [filter]: !isSelected,
        },
        selectedFilters: isSelected
          ? prevState.selectedFilters.filter((selected) => selected !== filter)
          : [...prevState.selectedFilters, filter],
      };
    });
  };
  filterResults = (filter) => {
    // Implement your filtering logic here based on the selected filter
    console.log("Filter:", filter);
    // Update the displayed results accordingly
  };
  handleSearchBarFocus = () => {
    this.setState({ showPanel: true });
  };

  handleClosePanel = () => {
    this.setState({ showPanel: false });
  };

  handleInputChange = (event) => {
    this.setState({ query: event.target.value });
  };

  handleSearchIconClick = () => {
    console.log("SELECTED FILTERS", this.state.selectedFilters);
    this.handleFilterBasedCalls();
  };

  handleFilterBasedCalls = () => {
    const filterFunctions = {
      all: () => {
        this.getTextResults();
        this.getVoiceResults();
        console.log("BOTH FILTERS CALL GONE");
      },
      voice: () => {
        this.setState({ voiceResultLoading: true });
        this.getVoiceResults();
        console.log("CALL GONE FOR VOICE ONLY");
      },
      text: () => {
        this.setState({ textResultLoading: true });
        this.getTextResults();
        console.log("CALL GONE FOR TEXT ONLY");
      },
    };

    const selectedFilters = this.state.selectedFilters;

    for (const filter of selectedFilters) {
      const filterFunction = filterFunctions[filter];
      if (filterFunction) {
        filterFunction();
      }
    }
  };

  handleKeyUp = (event) => {
    if (event.key === "Enter") {
      console.log("SELECTED FILTERS", this.state.selectedFilters);
      this.handleFilterBasedCalls();
    }
  };
  getTextResults = () => {
    const { query } = this.state;
    // Call your getTextResults method with the query

    console.log(
      "Getting results for : ",
      query,
      "   ",
      this.props.meetingId,
      "  ",
      this.props.accessToken
    );
    // Make your API call using the access token
    if (this.props.accessToken) {
      try {
        this.props
          .searchTextInMeeting(
            this.props.accessToken,
            query,
            this.props.meetingId
          )
          .then((result) => {
            const textMatchedResults = result.data;

            this.setState({ textMatchedResults });
            this.setState({ textResultLoading: false });
          })
          .catch((err) => {});
      } catch (error) {
        console.error("Error fetching Text search:", error);
      }
    } else {
      console.log("accessToken not present");
    }
  };
  getVoiceResults = () => {
    const { query } = this.state;
    // Call your getTextResults method with the query

    // Make your API call using the access token
    if (this.props.accessToken) {
      try {
        this.props
          .searchVoiceInMeeting(
            this.props.accessToken,
            query,
            this.props.meetingId
          )
          .then((result) => {
            const voiceMatchedResults = result.data;

            this.setState({ voiceMatchedResults });

            this.setState({ voiceResultLoading: false });
            // this.renderVoiceContentResults(query, matchedResults);
          })
          .catch((err) => {});
      } catch (error) {
        console.error("Error fetching Text search:", error);
      }
    } else {
      console.log("accessToken not present");
    }
  };
  renderTextContentSearchResults = (query, textMatchedResults) => {
    let queryResults;
    const singleResult = (match, index) => {
      const boundingBoxes = (words, scale) => {
        console.log("WORDS: ", words);
        return (
          <BoundingBoxes>
            {words
              .map((word) => word.box)
              .map((box) => (
                <BoundingBox
                  x={box.x}
                  y={box.y}
                  height={box.height}
                  width={box.width}
                  scale={scale}
                />
              ))}
          </BoundingBoxes>
        );
      };
      const timestamp = moment("2020-01-01 00:00:00").add(
        moment.duration(match.timestamp)
      );
      const timestampFormatted =
        timestamp.hour() !== 0
          ? timestamp.format("H:mm:ss")
          : timestamp.format("m:ss");
      const seconds = moment.duration(match.timestamp) / 1000;

      return (
        <SingleTextResult>
          {
            // place bounding boxes before adding the image below.
            boundingBoxes(match.matches, match.scale)
          }
          {/*<img src={match.imageUrl} alt="broken result" style={{maxHeight: "180px", maxWidth: "260px"}}/>*/}
          <img
            src={match.image_path}
            alt="broken result"
            style={{ maxHeight: "200px", maxWidth: "200px" }}
          />

          <MeetingResult
            onClick={() => this.forwardMeeting(this.props.meetingId, seconds)}
          >
            {timestampFormatted}
          </MeetingResult>
        </SingleTextResult>
      );
    };

    if (query.length === 0 && !this.state.textMatchedResults)
      queryResults = (
        <InformationalTextForSearch>
          Search for written content in your meetings (e.g. text written on a
          whiteboard or slides). For reference, a one-hour meeting recording may
          take about 10 minutes before becoming searchable. We will notify you
          by email when your meeting is ready to be searched.
        </InformationalTextForSearch>
      );
    else if (textMatchedResults.length === 0) {
      queryResults = (
        <InformationalTextForSearch>
          Nothing matched for "{query}".
        </InformationalTextForSearch>
      );
    } else {
      queryResults = textMatchedResults.map((match, index) =>
        singleResult(match, index)
      );
    }

    return <TextResultContainer>{queryResults}</TextResultContainer>;
  };

  renderVoiceContentResults = (query, voiceMatchedResults) => {
    let queryResults;

    if (query.length === 0 && !this.state.voiceMatchedResults)
      queryResults = (
        <InformationalTextForSearch>
          Search for things discussed during your meetings. For reference, a
          one-hour meeting recording may take about 10 minutes before becoming
          searchable. We will notify you by email when your meeting is ready to
          be searched.
        </InformationalTextForSearch>
      );
    else if (voiceMatchedResults.length === 0) {
      queryResults = (
        <InformationalTextForSearch>
          Nothing matched for "{query}".
        </InformationalTextForSearch>
      );
    } else {
      // eslint-disable-next-line no-useless-escape
      const wordsInQuery = query.toLowerCase().split(/[ \.,]+/);
      queryResults = voiceMatchedResults.map((match, index) => {
        const seconds = moment.duration(match.timestamp);
        return (
          <VoiceContentSearchResult
            key={`vs_${index}`}
            meetingName={""}
            meetingId={match.meeting_id}
            matchedContent={match.matched_content}
            time={match.timestamp}
            wordsInQuery={wordsInQuery}
            onOpenMeetingModal={() =>
              this.forwardMeeting(this.props.meetingId, seconds)
            }
          />
        );
      });
    }

    return (
      <div style={{ color: "black", fontSize: "1rem", fontWeight: "500" }}>
        {queryResults}
      </div>
    );
  };
  forwardMeeting = async (meetingId, seconds) => {
    document.getElementById("videoContainer").scrollIntoView({
      behavior: "smooth",
    });
    this.props.getMeetingRecording(this.props.accessToken, meetingId, seconds);
    this.handleClosePanel();
  };
  render() {
    const { filters, selectedFilters, showPanel, query } = this.state;
    const searchInputBar = (
      <SearchInputBar>
        <InputVioletBorder
          placeholder="Our AI can search for any moment in your video"
          onFocus={this.handleSearchBarFocus}
          onChange={this.handleInputChange}
          onKeyUp={this.handleKeyUp}
          value={query}
        />
        <IconWrapper onClick={this.handleSearchIconClick}>
          {query && <PlaceHolderHelp>Press Enter</PlaceHolderHelp>}
          <Icon name="search_purple_icon" alt="search" />
        </IconWrapper>
      </SearchInputBar>
    );
    return (
      <Container>
        <SearchBarContainer>{searchInputBar}</SearchBarContainer>
        {showPanel && (
          <PanelContainer>
            <CrossIcon
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                color: "black",
              }}
              onClick={this.handleClosePanel}
            >
              &times;
            </CrossIcon>
            <Heading>Filters</Heading>
            <FilterButtonsContainer>
              {Object.keys(filters).map((filter) => (
                <FilterButton
                  key={filter}
                  enabled={filters[filter]}
                  onClick={() => this.toggleFilter(filter)}
                >
                  {filter.charAt(0).toUpperCase() + filter.slice(1)}
                  {filters[filter] && <CrossIcon>&times;</CrossIcon>}
                </FilterButton>
              ))}
            </FilterButtonsContainer>
            <Heading>
              {/* {selectedFilters.length > 0
                ? `Filtering by: ${selectedFilters
                    .map(
                      (filter) =>
                        filter.charAt(0).toUpperCase() + filter.slice(1)
                    )
                    .join(", ")}`
                : "Filters"} */}
            </Heading>
            {/* <Heading>Voice Results</Heading> */}
            {selectedFilters.map((selectedFilter) => (
              <div
                style={{
                  position: "relative",
                  minHeight: "100px",
                  border: "1px solid black",
                  padding: "10px",
                  marginBottom: "10px",
                  maxHeight: "500px",
                  overflow: "scroll",
                  overflowX: "hidden",
                }}
                key={selectedFilter}
              >
                <Heading>{selectedFilter} Results</Heading>

                {selectedFilter === "voice" ? (
                  !this.state.voiceResultLoading ? (
                    this.state.voiceMatchedResults ? (
                      this.renderVoiceContentResults(
                        this.state.query,
                        this.state.voiceMatchedResults
                      )
                    ) : (
                      <ResultPlaceHolder>
                        Your results will be shown here
                      </ResultPlaceHolder>
                    )
                  ) : (
                    <CustomSpinner size={40} />
                  )
                ) : (
                  <></>
                )}

                {selectedFilter === "text" ? (
                  !this.state.textResultLoading ? (
                    this.state.textMatchedResults ? (
                      this.renderTextContentSearchResults(
                        this.state.query,
                        this.state.textMatchedResults
                      )
                    ) : (
                      <ResultPlaceHolder>
                        Your results will be shown here
                      </ResultPlaceHolder>
                      // <></>
                    )
                  ) : (
                    <CustomSpinner size={40} />
                  )
                ) : (
                  <></>
                )}
              </div>
            ))}
            {/* {this.state.matchedResults} */}
          </PanelContainer>
        )}
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    searchTextInMeeting: (accessToken, query, meetingId) =>
      dispatch(actions.searchTextInMeeting(accessToken, query, meetingId)),
    searchVoiceInMeeting: (accessToken, query, meetingId) =>
      dispatch(actions.searchVoiceInMeeting(accessToken, query, meetingId)),
    getMeetingRecording: (accessToken, meetingId, seconds) =>
      dispatch(actions.getMeetingRecording(accessToken, meetingId, seconds)),

    searchMeetingsForTextContent: (
      accessToken,
      query,
      meetingId,
      pageNumber = 1,
      pageSize = 12
    ) =>
      dispatch(
        actions.searchMeetingsForTextContent(
          accessToken,
          query,
          meetingId,
          pageNumber,
          pageSize
        )
      ),
    searchMeetingsForVoiceContent: (
      accessToken,
      query,
      meetingId,
      pageNumber = 1,
      pageSize = 10
    ) =>
      dispatch(
        actions.searchMeetingsForVoiceContent(
          accessToken,
          query,
          meetingId,
          pageNumber,
          pageSize
        )
      ),
    updateQueryType: (newQueryType) =>
      dispatch(actions.updateQueryType(newQueryType)),
    meetingNameUpdateHandler: (accessToken, meetingId, meetingName) =>
      dispatch(actions.updateMeetingName(accessToken, meetingId, meetingName)),
    viewMeetingRecording: (accessToken, meetingId, modalType, seconds) =>
      dispatch(
        actions.viewMeetingRecording(accessToken, meetingId, modalType, seconds)
      ),
    closeMeetingModal: (modalType) =>
      dispatch(actions.closeMeetingModal(modalType)),
  };
};

const mapStateToProps = (state) => {
  return {
    meetingModal: state.meetingModal,
    meetings: state.meetings,
    accessToken: state.auth.accessToken,
    meetingUpload: state.meetingUpload,
    userEmail: state.user.email,

    meetingId: state.specificMeeting.meetingId,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchPanel);
